import { useCallback } from 'react'

import { useDispatch } from 'react-redux'

import { actions as snactions } from 'store/snackbar'

export function useOnError(message: string): (alternateError?: string) => void
export function useOnError(): (message: string) => void
export function useOnError(message?: string) {
  const dispatch = useDispatch()
  const onError = useCallback(
    (alternateError?: string) => {
      dispatch(snactions.addSnackbarItem(alternateError ?? message))
    },
    [dispatch, message],
  )

  return onError
}
